// extracted by mini-css-extract-plugin
export var buttonWrap = "EnhancedBenefits-module--buttonWrap--uZ2zc";
export var button_container = "EnhancedBenefits-module--button_container--xZsCk";
export var content_container = "EnhancedBenefits-module--content_container--enATU";
export var enhanced_benefit_container = "EnhancedBenefits-module--enhanced_benefit_container--3ttRE";
export var enhanced_benefits = "EnhancedBenefits-module--enhanced_benefits--dFdRk";
export var enhanced_benefits_container = "EnhancedBenefits-module--enhanced_benefits_container--UvxFB";
export var enhanced_benefits_intro = "EnhancedBenefits-module--enhanced_benefits_intro--VcRPe";
export var image = "EnhancedBenefits-module--image--E+zP-";
export var image_container = "EnhancedBenefits-module--image_container--YTuEY";
export var page404Title = "EnhancedBenefits-module--page404-title--5npPd";